export class ProjectModel {
    public projectName: string;
    public folderName: string;
    public mainPictureUrl: string;
    public pictureUrls: string[];
}